import type { Language } from '../contexts/LanguageContext';

const firstLetter = (value: string | undefined, locale: string): string => {
  if (!value) return '';
  return Array.from(value.trim()).find(character => character.toLocaleLowerCase(locale) !== character.toLocaleUpperCase(locale)) || '';
};

export const getPersonInitials = (
  firstName: string | undefined,
  lastName: string | undefined,
  language: Language,
  fallback?: string,
): string => {
  const locale = language === 'tr' ? 'tr-TR' : 'en-US';
  const initials = [firstLetter(firstName, locale), firstLetter(lastName, locale)].join('');
  const fallbackInitial = fallback?.trim() ? Array.from(fallback.trim())[0] : '';

  return (initials || fallbackInitial).toLocaleUpperCase(locale);
};

export const getDisplayNameInitials = (name: string | undefined, language: Language): string => {
  const words = name?.trim().split(/\s+/u).filter(Boolean) ?? [];
  return getPersonInitials(words[0], words.length > 1 ? words[words.length - 1] : undefined, language);
};
